import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { 
  Box, 
  List, 
  ListItem, 
  ListItemText, 
  Paper,
  Typography 
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledSidebar = styled(Paper)(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: 12,
  padding: theme.spacing(2),
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  color: 'white',
  position: 'sticky',
  top: 0,
  [theme.breakpoints.down('md')]: {
    position: 'relative',
    width: '100%',
    height: 'auto',
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(2),
  },
}));

const SidebarItem = styled(ListItem)<{ active: number }>(({ theme, active }) => ({
  borderRadius: 8,
  marginBottom: theme.spacing(1),
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  backgroundColor: active ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
  },
}));

interface SidebarProps {
  mobile?: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ mobile = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const featureItems = [
    { title: t('sidebar.taskManagement'), path: '/features/gorev-takibi' },
    { title: t('sidebar.staffManagement'), path: '/features/personel-yonetimi' },
    { title: t('sidebar.shiftTracking'), path: '/features/vardiya-takibi' },
    { title: t('sidebar.detailedReports'), path: '/features/raporlar' },
    { title: t('sidebar.messageNotifications'), path: '/features/bildirimler' },
    { title: t('sidebar.surveyManagement'), path: '/features/anket-yonetimi' },
    { title: t('sidebar.eventManagement'), path: '/features/etkinlik-yonetimi' },
    { title: t('sidebar.branchManagement'), path: '/features/sube-yonetimi' },
  ];

  return (
    <StyledSidebar elevation={0}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', px: 1 }}>
        {t('featuresPage.featureCardsTitle')}
      </Typography>
      <List disablePadding>
        <SidebarItem 
          active={location.pathname === '/features' ? 1 : 0}
          onClick={() => navigate('/features')}
        >
          <ListItemText 
            primary={t('sidebar.allFeatures')} 
            primaryTypographyProps={{ 
              fontSize: mobile ? '0.9rem' : '1rem', 
              fontWeight: location.pathname === '/features' ? 600 : 400,
            }} 
          />
        </SidebarItem>
        {featureItems.map((item, index) => (
          <SidebarItem 
            key={index} 
            active={location.pathname === item.path ? 1 : 0}
            onClick={() => navigate(item.path)}
          >
            <ListItemText 
              primary={item.title} 
              primaryTypographyProps={{ 
                fontSize: mobile ? '0.9rem' : '1rem',
                fontWeight: location.pathname === item.path ? 600 : 400, 
              }} 
            />
          </SidebarItem>
        ))}
      </List>
    </StyledSidebar>
  );
};

export default Sidebar; 